const AUTH_PUBLIC_PATHS = [
  '/login',
  '/forgot-password',
  '/api/auth/callback',
] as const;

/** Список и карточка документа без авторизации; /create — только с логином и пермишеном. */
function isPetsImportPublicRoute(path: string): boolean {
  const base = '/rules/pets-import';
  if (path === base || path === `${base}/`) {
    return true;
  }
  if (!path.startsWith(`${base}/`)) {
    return false;
  }
  const firstSegment = path.slice(`${base}/`.length).split('/')[0];
  if (!firstSegment) {
    return false;
  }
  return firstSegment !== 'create';
}

export function isPublicAuthPath(path: string): boolean {
  if ((AUTH_PUBLIC_PATHS as readonly string[]).includes(path)) {
    return true;
  }
  if (path.startsWith('/search/animals/')) {
    return true;
  }
  if (path.startsWith('/privacypolicy')) {
    return true;
  }
  return isPetsImportPublicRoute(path);
}
